export default "__VITE_ASSET__ba39576a__"